import React, { useState } from "react";
import { useT } from "../helpers/useT";
import {
  useFetch,
  constructApiUrl,
  PaginatedListResponse,
} from "../api/useFetch";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
} from "../components/List/Table";
import { Headline } from "../components/Headline";
import { EmptyListPlaceholder } from "../components/List/EmptyList";
import { PaginationWithoutTotalCount } from "../components/List/List";
import { Status } from "../components/Status";
import DetailsLink from "../components/DetailsLink";
import { Vehicle } from "./vehicle";
import { AddRecordLink } from "../list/AddItemToListCTA";
// @ts-ignore
import { vehicleAdd } from "../routes";
// @ts-ignore
import { CanDos } from "types/Role";
import { ApiResponseAware } from "../api/ApiResponseAware";

const PAGE_LIMIT = 30;

export function VehicleList({ canDo }: { canDo: CanDos }) {
  const t = useT();
  const [currentPage, setCurrentPage] = useState(1);
  const getVehiclesCall = useFetch<PaginatedListResponse<Vehicle>>(
    constructApiUrl("/api/v1/vehicles", {
      offset: `${(currentPage - 1) * PAGE_LIMIT}`,
      limit: `${PAGE_LIMIT + 1}`,
    }),
  );

  return (
    <ApiResponseAware
      apiCall={getVehiclesCall}
      render={({
        results: vehicles,
        pagination,
      }: PaginatedListResponse<Vehicle>) => (
        <>
          <Headline title={t("vehicles.title")} flex={true}>
            {canDo.add && (
              <AddRecordLink link={vehicleAdd()}>
                {t("vehicles.add-item-link")}
              </AddRecordLink>
            )}
          </Headline>
          <EmptyListPlaceholder
            data={vehicles}
            title={t("vehicles.empty-list")}
          >
            <Table>
              <TableHead>
                <TableHeaderRow>
                  <TableHeaderCell width={120}>
                    {t("shared.plate")}
                  </TableHeaderCell>
                  <TableHeaderCell>{t("shared.model")}</TableHeaderCell>
                  <TableHeaderCell width={100}>
                    {t("shared.color")}
                  </TableHeaderCell>
                  <TableHeaderCell width={100}>
                    {t("shared.production-year")}
                  </TableHeaderCell>
                  <TableHeaderCell width={90}>
                    {t("shared.status")}
                  </TableHeaderCell>
                  <TableHeaderCell width={60} />
                </TableHeaderRow>
              </TableHead>
              <TableBody>
                {vehicles.slice(0, PAGE_LIMIT).map((vehicle) => (
                  <TableRow key={vehicle.uuid}>
                    <TableCell>{vehicle.plate}</TableCell>
                    <TableCell>{vehicle.model}</TableCell>
                    <TableCell>{vehicle.color || "-"}</TableCell>
                    <TableCell>{vehicle.year}</TableCell>
                    <TableCell>
                      <Status status={vehicle.state} />
                    </TableCell>
                    <TableCell>
                      <DetailsLink
                        section="vehicles"
                        qs={{ id: vehicle.uuid }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <PaginationWithoutTotalCount
              currentPage={currentPage}
              nextPage={
                vehicles.length === pagination.limit
                  ? currentPage + 1
                  : currentPage
              }
              onPageClick={setCurrentPage}
            />
          </EmptyListPlaceholder>
        </>
      )}
    />
  );
}
